export default __webpack_public_path__ + "static/media/homeCards1.33d8aec7.svg";